<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.siteName" placeholder="请输入查询关键字" @keydown.enter="resetSearch">
            <template #prefix>工地名称</template>
          </el-input>
          <employee-select v-model="searchInfo.leader">
            <template #prefix>负责人</template>
          </employee-select>
          <el-select v-model="searchInfo.status" placeholder="请选择工地状态" clearable>
            <template #prefix>工地状态</template>
            <el-option label="未开始" :value="0"/>
            <el-option label="进行中" :value="1"/>
            <el-option label="已完成" :value="100"/>
          </el-select>
        </template>
        <template #option>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
          <page-button hasPerm="project:site:save" el-type="success" @click="$router.push(`/project/site/detail`)">新建</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border page-name="siteList">
          <yq-table-column label="工地名称" prop="siteName" min-width="180rem"/>
          <yq-table-column label="负责人" prop="leaderName"/>
          <yq-table-column label="所属项目" prop="projectName"/>
          <yq-table-column label="项目阶段" prop="sitePhase">
            <template v-slot="{row}">
              <span v-for="it in sitePhaseList" :key="it.id" >
                <span v-if="row.sitePhase === it.dictCode">{{ it.dictName }}</span>
              </span>
            </template>
          </yq-table-column>

          <yq-table-column label="项目进度" prop="progress">
            <template v-slot="{row}">{{ row.progress }}%</template>
          </yq-table-column>
          <yq-table-column label="项目状态" prop="status">
            <template #default="{row}">
              <el-tag v-if="row.status === 0" type="info">未开始</el-tag>
              <el-tag v-if="row.status === 1" type="success">进行中</el-tag>
              <el-tag v-if="row.status === 100" type="warning">已完成</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem"
                           :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button hasPerm="project:site:save" @click="$router.push(`/project/site/detail?id=${row.id}`)">编辑</table-button>
                <table-button hasPerm="project:site:history" @click="toShowHistory(row)">历程</table-button>
                <table-button hasPerm="project:site:remove" el-type="danger" message="是否确认删除数据" @click="deleteRow(row.id)">
                  删除
                </table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
    <data-history :data-list="historyList" ref="history" header-Name="事件信息" :title="currentData.siteName + '历程'">
      <template #info="{row}">{{row.desc}}</template>
      <template #option="{row}">{{row.operateName || '-'}}</template>
    </data-history>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import siteApi from "@/api/dz-luqiao/luqiaoSiteApi";
import commonApi from "@/api/commonApi";
import util from "@/util/util"
import DataHistory from "@/components/h5/data/DataHistory.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "SiteList",
  components: {
    EmployeeSelect, DataHistory, YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      sitePhaseList: [],
      showHistory: false,
      currentData: {},
      historyList: [],
      userInfo: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    this.resetSearch();
    this.userInfo = await util.getUserInfo();
     commonApi.queryDictionaryList("PROJECT_PHASE", this.userInfo.merchantId).then(list => {
       this.sitePhaseList = list;
    })
  },
  methods: {
    async queryList() {
      const {records, totalCount} = await siteApi.list(this.searchInfo)
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    async deleteRow(id) {
      await siteApi.delete(id)
      this.resetSearch()
    },
    toShowHistory(data) {
      // 显示历程
      this.currentData = data;
      this.historyList = [];
      siteApi.queryHistory(data.id).then(list => {
        // 添加颜色
        for (let i = 0; i < list.length; i++) {
          switch (list[i].historyType) {
            case 'SITE_NEW':
              list[i].colorIndex = 2;
              break;
            case 'SITE_START':
              list[i].colorIndex = 2;
              break;
            case 'SITE_END':
              list[i].colorIndex = 1;
              break;
            case 'CLASSMATE_JOIN':
              list[i].colorIndex = 6;
              break;
            case 'CLASSMATE_LEAVE':
              list[i].colorIndex = 7;
              break;
            case 'PHASE_CHANGE':
              list[i].colorIndex = 8;
              break;
            case 'CHECK':
              list[i].colorIndex = 4;
              break;
            default:
              break;
          }
        }
        this.historyList = list;
        this.$refs.history.showData();
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>